<template>
    <div>
        <div class="modal fade" id="registerModalToggleEu" aria-hidden="true"
            aria-labelledby="registerModalToggleEuLabel" tabindex="-1" data-bs-backdrop="false"
            style="background-color:rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" :style="skin.my_account.main_background">
                    <div class="modal-header" style="border-bottom: none;">
                        <button :style="skin.my_account.close_btn" style="background: none;" type="button"
                            class="btn-close" data-bs-dismiss="modal" aria-label="Close"><i
                                class="fas fa-times"></i></button>
                    </div>
                    <div class="modal-body">
                        <!-- Captcha: solo visible antes de verificar -->
                        <div v-if="!captchaVerified" >
                            <div class="d-flex justify-content-center">
                                <div id="recaptcha-container" style="display: block;"></div>
                            </div>
                        </div>                        
                        <div v-if="captchaVerified" class="text-center p-2">
                            <img v-if="skin.header_desktop.logo != ''" :src="skin.header_desktop.logo"
                                :width="skin.header_desktop.login_logo_width" alt=""><br><br>
                            <span>{{ translate('new_user') }}</span><br>
                            <span>{{ translate('register_easy') }}</span><br><br>
                            <form @submit.prevent="nextStep()">
                                <div class="mb-3">
                                    <label for="registerEmail1">{{ translate('username') }}</label>
                                    <input v-model="new_user_data.username" type="text" id="registerEmail1"
                                        class="form-control" :placeholder="translate('enter_email')"
                                        aria-label="registerEmail" aria-describedby="registerEmail" required>
                                </div>
                                <div class="mb-3">
                                    <label for="RegisterPassword1">{{ translate('password') }}</label>
                                    <input v-model="new_user_data.password" id="RegisterPassword1" type="password"
                                        class="form-control" :placeholder="translate('enter_password')"
                                        aria-label="RegisterPassword1" aria-describedby="RegisterPassword1" required>
                                </div>
                                <button type="submit" :style="skin.qbet.booking_btn" class="p-2 text-center mb-2"
                                    style="width:100%;color:white">{{ translate('confirm') }}</button>
                                <button data-bs-target="#registerModalToggle4" data-bs-toggle="modal"
                                    data-bs-dismiss="modal" id="nextForm1" style="display:none;"></button>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="registerModalToggle4" aria-hidden="true" aria-labelledby="registerModalToggle4Label"
            tabindex="-1" data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" :style="skin.my_account.main_background">
                    <div class="modal-header" style="border-bottom: none;">
                        <h5>{{ translate('end_registration') }}</h5>
                        <button :style="skin.my_account.close_btn" style="background: none;" type="button"
                            class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="CERRARregister"><i
                                class="fas fa-times"></i></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div v-if="status.result != 'OK'" class="alert alert-danger" role="alert">
                                {{ status.msg }}
                            </div>
                            <form @submit.prevent="register()">
                                <div v-if="skin.register_fields.idn" class="mb-3">
                                    <label for="registerId1">{{ translate('idn') }}</label>&nbsp;
                                    <span v-if="cpf_loading" class="spinner-border" :style="skin.loader" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </span>
                                    <span v-if="skin.register_fields.cpf_verification && cpf_message != ''"
                                        v-html="cpf_message"
                                        style="color: #842029;background-color: #f8d7da;border-color: #f5c2c7;border: 1px solid transparent;border-radius: 0.25rem;"
                                        class="px-2"></span>
                                    <input v-model="idn" @blur="verify_cpf()" type="number" id="registerId1"
                                        class="form-control" placeholder="Ingrese aquí" aria-label="registerId"
                                        aria-describedby="registerId">
                                </div>
                                <div v-if="skin.register_fields.name" class="mb-3">
                                    <label for="registerFirstName1">{{ translate('name') }}</label>
                                    <input v-model="new_user_data.firstname" type="text" id="registerFirstName1"
                                        class="form-control" :placeholder="translate('enter_here')"
                                        aria-label="registerFirstName" aria-describedby="registerFirstName"
                                        :readonly="skin.register_fields.cpf_verification">
                                </div>
                                <div v-if="skin.register_fields.last_name" class="mb-3">
                                    <label for="registerLastName1">{{ translate('last_name') }}</label>
                                    <input v-model="new_user_data.last_name" type="text" id="registerLastName1"
                                        class="form-control" :placeholder="translate('enter_here')"
                                        aria-label="registerLastName" aria-describedby="registerLastName">
                                </div>
                                <div v-if="skin.register_fields.cpf_verification" class="mb-3">
                                    <label for="birthday">{{ translate('birthday') }}</label>
                                    <input v-model="birthday" type="text" id="birthday" class="form-control"
                                        placeholder="Dia/Mês/Ano" aria-label="birthday" aria-describedby="birthday"
                                        readonly>
                                </div>
                                <div v-if="skin.register_fields.name" class="mb-3">
                                    <label for="registeremail">{{ translate('email') }}</label>
                                    <input v-model="new_user_data.email" type="text" id="registeremail"
                                        class="form-control" :placeholder="translate('enter_here')"
                                        aria-label="registeremail" aria-describedby="registeremail">
                                </div>
                                <div v-if="skin.register_fields.country" class="mb-3">
                                    <label for="registerCountry1">{{ translate('country') }}</label>
                                    <select class="form-control" name="country" v-model="new_user_data.country"
                                        id="registerCountry1" required>
                                        <option v-for="(country, index) in countries()" :key="index"
                                            :value="country.iso_3">{{ language == "es" ? country.name_es :
                                                country.name_en
                                            }}</option>
                                    </select>
                                </div>
                                <div v-if="skin.register_fields.currency" class="mb-3">
                                    <label for="registerCurrency1">{{ translate('currency') }}</label>
                                    <select class="form-control" name="currency" v-model="new_user_data.currency"
                                        id="registerCurrency1" required>
                                        <option v-for="currency in currencies" :key="currency" :value="currency">{{
                                            currency }}</option>
                                    </select>
                                </div>
                                <div v-if="skin.register_fields.phone_number" class="mb-3">
                                    <label for="registerCurrency">{{ translate('phone') }}</label>&nbsp;&nbsp;<span
                                        v-if="!phone_code_checked"
                                        style="color: #842029;background-color: #f8d7da;border-color: #f5c2c7;border: 1px solid transparent;border-radius: 0.25rem;"
                                        class="px-2">{{ translate('incorrect_code') }}</span>
                                    <div class="d-flex">
                                        <div class="input-group me-1" style="width:40%">
                                            <span class="input-group-text" id="basic-addon1">+</span>
                                            <input :style="!phone_code_checked ? 'border-color:red;' : ''" type="number"
                                                v-model="phone_code" class="form-control"
                                                :placeholder="translate('country_code')"
                                                :disabled="skin.register_fields.default_phone_code != 0">
                                        </div>
                                        <div style="width:60%;">
                                            <input v-model="phone" type="number" class="form-control"
                                                :placeholder="translate('enter_number')">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-check mb-3">
                                    <input class="form-check-input" type="checkbox" value="" v-model="agreement"
                                        required>
                                    <label class="form-check-label" for="flexCheckDefault">
                                        {{ translate('aggrement') }} <span @click="terms()" class="link-primary">{{
                                            translate('see_aggrement') }}</span>
                                    </label>
                                </div>
                                <div class="text-center">
                                    <span v-if="register_inProcess" class="spinner-border" :style="skin.loader"
                                        role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </span>
                                </div>
                                <button type="submit" :style="skin.qbet.confirm_btn" class="p-2 text-center mb-2"
                                    style="width:100%;color:white" :disabled="register_inProcess">{{
                                        translate('confirm') }}</button>
                                <button :style="skin.qbet.booking_btn" class="btn btn-primary" style="width:100%;"
                                    data-bs-target="#registerModalToggle" data-bs-toggle="modal"
                                    data-bs-dismiss="modal">{{ translate('back') }}</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <VerifyNumber v-if="phone && phone_code" :skin="skin" :language="language" :translation="translation"
            :datos="{ phone_code, phone }" />
        <button data-bs-target="#phoneVericationModaleu" data-bs-toggle="modal" data-bs-dismiss="modal"
            style="display:none;" id="phoneVericationModaleuBtn"></button>
        <div class="modal fade" id="phoneVericationModaleu" aria-hidden="true" aria-labelledby="phoneVericationModaleu"
            tabindex="-1" data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" :style="skin.my_account.main_background">
                    <div class="modal-header" style="border-bottom: none;">
                        {{ translate('phone_verification') }}
                        <button :style="skin.my_account.close_btn" style="background: none;" type="button"
                            class="btn-close" data-bs-dismiss="modal" aria-label="Close"><i
                                class="fas fa-times"></i></button>
                    </div>
                    <div class="modal-body">
                        <div class="text-center">
                            <span v-if="phone_verification.loading" class="spinner-border" :style="skin.loader"
                                role="status">
                                <span class="visually-hidden">Loading...</span>
                            </span>
                            <div v-else :class="'alert alert-' + phone_verification.message.type" role="alert">
                                {{ phone_verification.message.message }}
                            </div>
                        </div>
                        <form v-if="!phone_verification.code_checked" class="text-center p-2"
                            @submit.prevent="verify_phone()">
                            <input v-model="phone_verification.code" type="number" step="1" required><br><br>
                            <button type="submit" :style="skin.qbet.confirm_btn" class="p-2 text-center mb-2"
                                style="width:100%;color:white">{{ translate('confirm') }}</button>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VerifyNumber from "./VerifyNumber.vue";
import VueRecaptcha from 'vue-recaptcha';
// const countries = require('../../../assets/countries.json');
import axios from 'axios';
export default {
    name: "register_eujogo",
    props: ['skin', 'translation', 'language'],
    components: {
        VerifyNumber,
        VueRecaptcha 
    },
    data() {
        return {
            recaptchaWidgetId: null,
            captchaVerified: false,
            countries_array:{countries: [
                {
                "name_en": "Brazil",
                "name_es": "Brasil",
                "dial_code": "+55",
                "code": "BR",
                "iso_3": "BRA"
                }
            ]},
            selected_country: "",
            email: "",
            password: "",
            first_name: "",
            last_name: "",
            idn: "",
            cpf_message: "",
            cpf_verified: true,
            cpf_loading: false,
            birthday: "",
            gender: "",
            country_code: "",
            phone_code: "",
            phone_code_checked: true,
            phone_verification: {
                code_checked: false,
                code: "",
                otp_id: "",
                loading: false,
                message: {
                    type: "",
                    message: ""
                }
            },
            phone: "",
            currency_name: "",
            status: { result: "OK", msg: "" },
            agreement: false,
            register_inProcess: false,
            new_user_data: {
                affiliate_id: "",
                country: "",
                type: "",
                username: "",
                email: "",
                firstname: "",
                dni: "",
                password: "",
                phone: "",
                currency: "",
                login_Id: 0,
                poker: 0,
                casino: 0,
                deportes: 0,
                proveedores: {
                    poker: { status: true, comision: "0%" }, casino: [], deportes: { status: true, comision: "0%" }, bingo: { status: true, comision: "0%" },
                    casinoLive: { status: true, comision: "0%" }, hipicas: { status: true, comision: "0%" },
                    casinoTotal: "", pokerTotal: "", deportesTotal: "", bingoTotal: "", casinoLiveTotal: "", hipicasTotal: ""
                },
                error: "",
                liquidacion: "Mensual"
            },
        }
    },
    computed: {
        qtag() {
            let data = this.$store.getters['getQtag'];
            return data;
        },
        user() {
            let data = this.$store.getters['getUserData'];
            return data;
        },
        afiliado() {
            let data = this.$store.getters['getAfiliado'];
            // console.log(data)
            return data;
        },
        root() {
            let data = this.$store.getters['getRoot'];
            // console.log(data)
            return data;
        },
        apiUrlnew() {
            return this.$store.getters['getApiUrlnew'];
        },
        site() {
            console.log(this.$store.getters['getSite'])
            return this.$store.getters['getSite'];
        },
        currencies() {
            return ["BRL"];
        }
    },
    methods: {
        botonverify() {
            if (!this.phone_code || !this.phone) {
                alert('Faltan datos');
                return;
            }

            const modalElement = document.getElementById('verifynumber');
            const modal = new bootstrap.Modal(modalElement);
            modal.show();
        },
        terms() {
            let url = "";
            let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language == 'pt' ? 'pt-br' : 'spa'));
            if (this.user.prefix == "external") {
                url = "https://docs.sistemasw3.com/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" + this.user.site;
            }
            else {
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
                url = "https://docs.sistemasw3.com/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
            }

            window.open(url, '_blank').focus();
        },
        async register() {
            this.register_inProcess = true;
            //   console.log(this.afiliado,this.new_user_data,this.root)
            //   if(this.agreement && this.cpf_verified){
            //     if(this.$props.skin.register_fields.phone_verification && !this.phone_verification.code_checked){
            //         let text_phone_length_check = this.phone.toString().length < this.$props.skin.register_fields.phone_min_length ? false : true;
            //         if(text_phone_length_check){
            //             this.send_phone_code(1);
            //         }
            //         else{
            //             this.status.result = "failed";
            //             this.status.msg = this.translate("phone_min_length_warning") + " " + this.$props.skin.register_fields.phone_min_length;
            //             this.register_inProcess = false;
            //             return;
            //         }
            //     }
            //     else{
            //         const response_register = await axios.post(this.user.domain+'/swarm/remote/registro',data);
            //         if(response_register.data.result == 'OK'){
            //             document.getElementById('registerSuccessfull').click();
            //             this.register_inProcess = false;
            //         }
            //         else{
            //             this.status.result = response_register.data.result
            //             this.status.msg = response_register.data.msg
            //             this.register_inProcess = false;
            //         }
            //     }
            //   }
            //   else{
            //     this.register_inProcess = false;
            //   }
            try {
                let loginInfo = this.new_user_data.username != "" && this.new_user_data.password != "" ? true : false;
                let response;
                // console.log(!loginInfo)
                if (!loginInfo) {
                    this.new_user_data.error = "Debes completar los datos de Ingreso";
                    // createBtn.innerHTML = "Aceptar";
                    // createBtn.disabled = false;
                } else {
                    // console.log(this.afiliado.id)

                    let data = {};
                    data.country = this.new_user_data.country
                    data.affiliate_id = this.afiliado.affiliate_id ?? this.qtag ?? null;
                    data.username = this.new_user_data.username;
                    data.email = this.new_user_data.email;
                    data.firstname = this.new_user_data.firstname + "-" + this.new_user_data.dni;
                    data.password = this.new_user_data.password;
                    data.phone = '+' + this.phone_code + this.phone;
                    data.login_Id = this.afiliado.id ?? this.root.id;
                    data.token = this.afiliado.token ?? this.root.token;
                    data.site = this.site;
                    data.currency = this.new_user_data.currency
                    data.token = 'qCpxTbvkZBePznR'
                    data.cpf = this.idn
                    data.bonos = 1


                    data.proveedores = this.afiliado.proveedores ?? this.root.proveedores
                    // data.secondaryRole = this.new_user_data.type == "afiliado"?'afiliado':''


                    let endpoint = "crear_jugador";

                    // console.log(this.apiUrlnew + endpoint, data)
                    // Intentar la primera petición con la nueva URL
                    response = await axios.post(this.apiUrlnew + endpoint, data);
                    if (response.data.error) {
                        this.new_user_data.error = response.data.error;
                    }
                    await this.SendPin();
                    document.getElementById('CERRARregister').click();
                    this.$store.dispatch('storeQtag', data.affiliate_id)
                    this.register_inProcess = false;
                    this.botonverify();
                    // document.getElementById('verifynumber_btn1').click();
                    // document.getElementById('registerSuccessfull1').click()

                    // if (response.data.error) {
                    //     this.new_user_data.error = response.data.error;
                    //     createBtn.innerHTML = "Aceptar";
                    //     createBtn.disabled = false;
                    // } else {
                    //     this.$store.dispatch("getChildrenCapital2", this.$store.getters["getTargetUser"]);
                    //     this.showAlert("alert-success", "Proceso correcto", "Usuario creado con éxito");
                    //     createBtn.innerHTML = "Aceptar";
                    //     createBtn.disabled = false;
                    //     this.closeModal();
                    // }
                }
            } catch (error) {
                console.log(error);
                this.status.result = 'error'
                this.status.msg = "Username or affiliate already exist";
                this.register_inProcess = false;
            }
        },
        async SendPin() {
            if (!this.phone_code || !this.phone) {
                this.status.msg = "Llena los datos";
                this.status.result = 'error'
                return;
            }

            try {
                let domain = this.$store.getters["getApiUrlnew"];
                const response = await axios.post(`${domain}phone_auth`, {
                    phone: '+' + this.phone_code + this.phone,
                    token: "qCpxTbvkZBePznR"
                });
                if (response.data.code !== 200) {
                    this.status.msg = response.data.msg;

                }
                else if (response.data.code === 200) {
                    this.status.msg = "Código enviado correctamente ya puedes ingresar";
                }

            } catch (err) {
                this.status.msg = "No se pudo enviar el código. Intenta nuevamente.";
                this.status.result = 'error'
                console.error(err);
            }
        },
        async storeQtag(state, payload) {
            document.cookie = `qtag=${payload}; path=/; max-age=31536000`; // Caducidad de 1 día (86400 segundos)
        },
        async verify_cpf() {
            if (this.$props.skin.register_fields.cpf_verification && this.idn != "") {
                this.cpf_loading = true;
                let headers = {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiSm9yZ2UiLCJ0eXBlIjoiY2FzaW5vIn0.P2S-_xOrKmSzu0-7HaAiIJSKCLlvXd2N03yB5N_Xg-8'
                };
                const response = await axios.get('https://admin.eujogo.bet/deposit/bs2/checkcpf?cpf=' + this.idn, { headers: headers });
                if (response.data.data.nascimento) {
                    const date = response.data.data.nascimento;
                    this.first_name = response.data.data.nome;
                    this.birthday = date.slice(0, 2) + "/" + date.slice(2, 4) + "/" + date.slice(4, 8);
                    this.cpf_verified = true;
                    this.cpf_loading = false;
                    this.cpf_message = "";
                }
                else {
                    this.cpf_message = response.data.data.mensagem;
                    this.birthday = "";
                    this.cpf_verified = false;
                    this.cpf_loading = false;
                }
            }
        },
        async send_phone_code(flag) {
            if (flag == 2) {
                this.phone_verification.loading = true;
                let data_phone = { "command": "verify_phone", "params": { "phone": this.user.user_data.data.phone.replace("+", "").substring(2), "code": this.user.user_data.data.phone.replace("+", "").slice(0, 2) } }
                const response_phone_verification = await axios.post(this.user.domain + '/' + this.user.prefix + '/scommand?access_token=' + this.user.token + '&site=' + this.user.site, data_phone);
                document.getElementById('phoneVericationModalBtn').click();
                this.phone_verification.message.message = response_phone_verification.data.message;
                this.phone_verification.message.type = response_phone_verification.data.success ? "success" : "danger";
                this.phone_verification.loading = false;
                return "success";
            }
            else {
                this.phone_verification.loading = true;
                let phone_data = {
                    "phone_code": this.phone_code,
                    "phone": this.phone.replace(".", ""),
                    "lang": this.$props.language
                }
                let phone_response = await axios.post("https://jbets.online:3012/api/generate_otp", phone_data);
                if (phone_response.data.otp_id && (phone_response.data.status ? (phone_response.data.status == "OPEN" ? true : false) : false)) {
                    this.phone_verification.otp_id = phone_response.data.otp_id;
                    document.getElementById('phoneVericationModalBtn').click();
                    this.phone_verification.message.message = phone_response.data.message;
                    this.phone_verification.message.type = "success";
                    this.phone_verification.loading = false;
                    this.register_inProcess = false;
                    return "success";
                }
                this.register_inProcess = false;
                return "failed";
            }
        },
        async verify_phone() {
            if (this.phone_verification.otp_id == "") {
                this.phone_verification.loading = true;
                let data_phone = { "command": "check_verify_phone", "params": { "code": this.phone_verification.code } }
                const response_phone_verification = await axios.post(this.user.domain + '/' + this.user.prefix + '/scommand?access_token=' + this.user.token + '&site=' + this.user.site, data_phone);
                if (response_phone_verification.data.success) {
                    this.phone_verification.message.message = response_phone_verification.data.message;
                    this.phone_verification.message.type = "success";
                    this.phone_verification.code_checked = true;
                    this.phone_verification.loading = false;
                }
                else {
                    this.phone_verification.message.message = response_phone_verification.data.message;
                    this.phone_verification.message.type = "danger";
                    this.phone_verification.code_checked = false;
                    this.phone_verification.loading = false;
                }
            }
            else {
                this.phone_verification.loading = true;
                let data_phone = {
                    "otp_id": this.phone_verification.otp_id,
                    "code": this.phone_verification.code,
                    "lang": this.$props.language
                }
                let phone_response = await axios.post("https://jbets.online:3012/api/verify_otp", data_phone);
                if (phone_response.data.status) {
                    this.phone_verification.message.message = phone_response.data.message;
                    this.phone_verification.message.type = "success";
                    this.phone_verification.code_checked = true;
                    this.phone_verification.loading = false;
                    this.phone_verification.otp_id = "";
                    this.register();
                }
                else {
                    this.phone_verification.message.message = phone_response.data.message;
                    this.phone_verification.message.type = "danger";
                    this.phone_verification.code_checked = false;
                    this.phone_verification.loading = false;
                }
            }
        },
        nextStep() {
            document.getElementById('nextForm1').click();
        },
        countries() {
            let country_list = [];
            this.countries_array.countries.forEach(country => {
                country_list.push(country);
            })
            return country_list.sort((a, b) => (a[this.$props.language == "es" ? "name_es" : "name_en"] > b[this.$props.language == "es" ? "name_es" : "name_en"]) ? 1 : -1)
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        // Este método se llama cuando se abre el modal
        initRecaptcha() {
            // Renderizar el captcha visible
            this.recaptchaWidgetId = window.grecaptcha.render("recaptcha-container", {
                sitekey: "6LdS9GIrAAAAAGaxHq81PsrKPe5BDEFyworIbmyT",
                callback: this.onCaptchaVerified,
                "expired-callback": this.onCaptchaExpired,
            });
        },
        async onCaptchaVerified(token) {
             try {
                const response = await axios.post(this.apiUrlnew + 'verify_captcha', { token });
                // console.log("✅ reCAPTCHA verificado:", response.data);
                if (response.data.success) {
                    this.captchaVerified = true;
                    // Aquí puedes continuar mostrando el formulario
                } else {
                    alert("❌ reCAPTCHA inválido, por favor inténtalo de nuevo");
                    this.captchaVerified = false;
                    // Reinicia el captcha manualmente si fue inválido
                    if (this.recaptchaWidgetId !== null) {
                        window.grecaptcha.reset(this.recaptchaWidgetId);
                    }
                }
            } catch (error) {
                console.error("⚠️ Error verificando el token:", error.response??error);
                alert("Error verificando el captcha");
                this.captchaVerified = false;
                // Reinicia el captcha automáticamente si hubo error
                if (this.recaptchaWidgetId !== null) {
                    window.grecaptcha.reset(this.recaptchaWidgetId);
                }
            }
        },
        onCaptchaExpired() {
            console.warn("⚠️ reCAPTCHA expirado");
            this.captchaVerified = false;

            if (this.recaptchaWidgetId !== null) {
                window.grecaptcha.reset(this.recaptchaWidgetId);
                // ❌ Ya no usamos execute porque es solo para captcha invisible
                // window.grecaptcha.execute(this.recaptchaWidgetId);
            }
        },
    },
    watch: {
        phone_code(newVal) {
            let code = "+" + newVal;
            let checkCode = false;
            this.countries_array.forEach(country => {
                if (code == country.dial_code) {
                    checkCode = true;
                }
            })
            this.phone_code_checked = checkCode;
        }
    },
    mounted() {
        // Cuando el script de reCAPTCHA carga, inicializamos
        window.onRecaptchaLoadCallback = () => {
            this.initRecaptcha();
        };

        // Si el script ya está disponible (por recarga), también lo inicializamos
        if (window.grecaptcha && window.grecaptcha.render) {
            this.initRecaptcha();
        }
        if (this.$props.skin.register_fields.default_country != "") {
            this.country_code = this.$props.skin.register_fields.default_country;
        }
        if (this.$props.skin.register_fields.default_phone_code != 0) {
            this.phone_code = this.$props.skin.register_fields.default_phone_code;
        }
        if (this.$props.skin.register_fields.default_currency != "") {
            this.currency_name = this.$props.skin.register_fields.default_currency;
        }
    }
}
</script>

<style></style>